<template>
  <div>
    <div class="top-box whiteBg">
      <search-input @search="handleSearch"></search-input>
    </div>
    <div class="main-box">
      <van-pull-refresh
        v-model="isRefresh"
        :head-height="80"
        @refresh="onRefresh"
      >
        <div :style="{ height: height }">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            ref="listbox"
          >
            <div
              class="whiteBg addressItem"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="item-main flex bbm" @click="handleChoose(item)">
                <div class="top-left">
                  <div class="item-top">
                    {{ item.myName }} {{ item.phone }}
                    <span class="certified" v-show="item.realnameFlag"
                      >已实名</span
                    >
                  </div>
                  <div class="address-detail">
                    {{
                      item.province + item.city + item.district + item.address
                    }}
                  </div>
                </div>
                <div class="top-right" @click.stop="toEdit(item)">
                  <van-icon name="edit" class="icon" />
                </div>
              </div>
              <div id="defaultAddress">
                <van-checkbox
                  v-model="item.defaultFlag"
                  checked-color="#ee0a24"
                  icon-size="24px"
                  @change="change(item)"
                  @click="changeDefault(item)"
                >
                  默认地址
                </van-checkbox>
              </div>
            </div>
          </van-list>
          <van-empty
            image="search"
            description="没有找到匹配的信息"
            v-if="list.length === 0 && searchKey !== ''"
          />
          <div class="empty" v-if="list.length === 0 && searchKey === ''">
            <div>暂无地址</div>
            <div>请点击下方按钮添加</div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <div class="footer whiteBg flex">
      <div class="placeOrder flex" @click="toAdd()">添加地址</div>
    </div>
  </div>
</template>
<script>
import searchInput from '@/components/search'
export default {
  data() {
    return {
      isRefresh: false,
      loading: false,
      finished: false,
      checked: true,
      list: [],
      currentPage: 0,
      height: 0,
      searchKey: ''
    }
  },
  components: {
    searchInput
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 120 + 'px'
  },
  methods: {
    getList() {
      let params = {
        type: 0,
        pageNum: this.currentPage,
        pageSize: 10
      }
      if (this.searchKey) {
        params = Object.assign(params, { searchKey: this.searchKey })
      }
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .getUserAddressList(data)
        .then(res => {
          this.loading = false
          this.isRefresh = false
          if (res.code === 0) {
            if (this.currentPage === 1) {
              this.list = []
            }
            this.list = this.list.concat(res.data.rows)
            if (this.list.length > 0) {
              this.sortAddress(this.list)
            }
            if (
              res.data.rows.length === 0 ||
              this.list.length >= res.data.totalCount
            ) {
              this.finished = true // 全部数据加载完了
            } else {
              this.finished = false
            }
          } else {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
          this.isRefresh = false
          this.finished = true
        })
    },
    onLoad() {
      this.currentPage++
      this.getList()
    },
    onRefresh() {
      this.currentPage = 1
      this.getList()
    },
    handleSearch(form) {
      this.searchKey = form
      this.onRefresh()
    },
    toEdit(item) {
      this.$router.push({
        name: 'senderInfo',
        query: { addressId: item.addressId }
      })
    },
    change(e) {
      if (e.defaultFlag) {
        // console.log(e)
        for (const i of this.list) {
          i.defaultFlag = 0
        }
        e.defaultFlag = 1
      }
    },
    changeDefault(item) {
      let obj = JSON.parse(JSON.stringify(item))
      delete obj.realnameFlag
      delete obj.type
      delete obj.userId
      if (item.defaultFlag === false) {
        obj.defaultFlag = 0
        let data = this.$Base64.encode(JSON.stringify(obj))
        this.$api.editUserAddress(data).then(res => {
          if (res.code === 0) {
            console.log('修改成功')
            this.onRefresh()
          }
        })
        return
      }
      // if (num === 1) {
      //   item.defaultFlag = 1
      //   return
      // }

      this.$api.changeSenderDefault({ addressId: item.addressId }).then(res => {
        if (res.code === 0) {
          this.onRefresh()
          setTimeout(() => {
            this.backTop()
          }, 200)
        }
      })
    },
    handleChoose(item) {
      this.$store.commit('set_senderInfo', item)
      this.$router.go(-1)
      // window.history.go(-1)
    },
    toAdd() {
      this.$router.push({ path: '/senderInfo' })
    },
    sortAddress(oldArr) {
      if (oldArr) {
        let obj = null
        for (let i in oldArr) {
          if (oldArr[i].defaultFlag === 1) {
            obj = oldArr[i]
            oldArr.splice(i, 1) // 如果数据组存在该元素，则把该元素删除
            break
          }
        }
        if (obj) {
          oldArr.unshift(obj) // 再添加到第一个位置
          this.list = oldArr
        }
      }
    },
    backTop() {
      // const that = this
      let timer = setInterval(() => {
        let scrollTop = document.getElementsByClassName('van-pull-refresh')[0]
          .scrollTop
        let ispeed = Math.floor(-scrollTop / 6)
        if (scrollTop === 0) {
          clearInterval(timer)
        }
        document.getElementsByClassName(
          'van-pull-refresh'
        )[0].scrollTop += ispeed
      }, 16)
    }
  }
}
</script>
<style lang="scss" scoped>
.top-box {
  padding: 0 10px 10px;
  overflow: hidden;
}
.empty {
  box-sizing: border-box;
  height: 100%;
  padding-top: 30vh;
  text-align: center;
}
.main-box {
  padding: 10px;
  .item-main {
    padding-bottom: 5px;
  }
  .addressItem {
    padding: 15px 15px 10px;
    margin-bottom: 10px;
    .certified {
      display: inline-block;
      padding: 4px;
      background-color: #7f7f7f;
      color: #fff;
      font-size: 12px;
      border-radius: 4px;
    }
    .top-left {
      flex: 1;
      .address-detail {
        word-break: break-all;

        font-size: 14px;
        margin-top: 4px;
        color: #555;
      }
    }
    .top-right {
      margin-left: 5px;
      .icon {
        font-size: 26px !important;
      }
    }

    #defaultAddress {
      padding-top: 8px;
      font-size: 14px;
    }
  }
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 54px;
  .placeOrder {
    width: calc(100% - 20px);
    height: 44px;
    border-radius: 22px;
    color: #fff;
    background-color: #a30014;
  }
}
</style>
<style lang="scss" scoped>
.van-icon-arrow,
.van-cell,
.van-checkbox__icon .van-icon {
  font-size: 16px !important;
}
.van-icon-search {
  font-size: 20px !important;
}
.van-pull-refresh {
  height: calc(100vh - 120px) !important;
  overflow: auto !important;
}
</style>
